import { useContext } from "react";

import { CongressContext } from "../components/congress-provider";

const useCongress = () => {
  const context = useContext(CongressContext);
  if (!context) {
    throw new Error("useCongress must be used within a CongressContext");
  }
  return context;
};

export { useCongress };
